<template>
    <Header />

    <UMain class="pb-20">
        <slot />
    </UMain>

    <Footer />
</template>
